<template>
    <q-page class="q-pa-md">
        <div class="row justify-center text-center text-h4">
            Welcome
        </div>
        <div class="row justify-center text-center text-h4" style="height: 3em">
            to Techdinamics Customer Portal
        </div>
        <div v-if="showLoginAction == true" class="row justify-center text-center">
            <q-btn color="primary" label="Log in" @click="onLoginActionClick()" />
        </div>
    </q-page>
</template>

<script>
    export { default } from './home-custom-screen.js'
</script>